<opac-dialog
  [open]="open"
  [title]="'common.information' | translate"
  (closed)="cancel.emit()"
>
  <div class="content">
    <p>{{'button.subscription.text1' | translate}}</p>
    <p>{{'button.subscription.text2' | translate}}</p>
  </div>

  <div slot="actions">
    <opac-button (click)="accept.emit()">{{ 'button.subscription.label' | translate }}</opac-button>
  </div>
</opac-dialog>
